import { render, staticRenderFns } from "./PageHabitsTrackerManager.vue?vue&type=template&id=aab3ea70"
import script from "./PageHabitsTrackerManager.vue?vue&type=script&lang=js"
export * from "./PageHabitsTrackerManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports